import { useEffect } from 'react'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { IsolatedPairOverview } from '@/features/isolated-details/types'
import { RepayDialogContentContainer } from './RepayDialogContentContainer'
import { track } from '@/features/analytics'

export interface RepayDialogProps extends CommonDialogProps {
  walletOverview: MyWalletProps
  pairOverview: IsolatedPairOverview
}

function RepayDialog({ open, setOpen, walletOverview, pairOverview }: RepayDialogProps) {
  useEffect(() => {
    track('lend_borrow_asset_selected', {
      token: String(pairOverview.borrowAsset.symbol),
      market: String(pairOverview.borrowAsset.address),
      market_type: 'isolated',
      action_type: 'repay',
    })
  }, [])

  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <RepayDialogContentContainer
          walletOverview={walletOverview}
          pairOverview={pairOverview}
          closeDialog={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}

export const repayDialogConfig: DialogConfig<RepayDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: RepayDialog,
}
